export const VALID_RENDERING_DETAILS_TYPE = {
    DISPLAY: "DISPLAY",
    SEPARATOR: "SEPARATOR",
    BUTTON: "BUTTON",
    FREE_TEXT_INPUT: "FREE_TEXT_INPUT",
    TOOLTIPDISPLAY: "TOOLTIPDISPLAY",
    TITLE: "TITLE",
    INFODISPLAY: "INFODISPLAY",
    COUPON_BUTTON: "COUPON_BUTTON",
    PAYMENT_COUPON_BUTTON: "PAYMENT_COUPON_BUTTON",
    COUPON_REMOVE_BUTTON: "COUPON_REMOVE_BUTTON",
    PAYMENT_COUPON_REMOVE_BUTTON: "PAYMENT_COUPON_REMOVE_BUTTON",
    COUPONLESS_SAVINGS: "COUPONLESS_SAVINGS",
    DELIVERY_FEE_DISCOUNT: "DELIVERY_FEE_DISCOUNT",
    TRANSPARENT_SEPARATOR: "TRANSPARENT_SEPARATOR",
    CARD_INFORMATION: "CARD_INFORMATION",
    SUPER_V3_NUDGE: "SUPER_V3_NUDGE",
    SUPER_V3_BENEFITS: "SUPER_V3_BENEFITS",
    DELIVERY_INSTRUCTIONS: "DELIVERY_INSTRUCTIONS",
    DELIVERY_SPEED: "DELIVERY_SPEED",
    DIRECT_COUPON_WIDGET_APPLY: "DIRECT_COUPON_WIDGET_APPLY",
    SELF_DELIVERY_INSTRUCTIONS: "SELF_DELIVERY_INSTRUCTIONS",
    OFFER_BUNDLE_BENEFITS: "OFFER_BUNDLE_BENEFITS",
    OFFER_BUNDLE_NUDGE: "OFFER_BUNDLE_NUDGE",
    HABIT_FORMATION: "HABIT_FORMATION", // rendering details key & type for habit formation in cart 2.0
    CART_CBCC_NUDGE: "CART_CBCC_NUDGE",
    SNACC_FREE_DEL_BENEFITS: "SNACC_FREE_DEL_BENEFIT",
    DELIVERY_FEE_SAVINGS: "DELIVERY_FEE_SAVINGS",
    REWARD_OFFER_SAVINGS: "REWARD_OFFER_SAVINGS",
    // gifting cart
    IM_COUPONLESS_SAVINGS: "IM_COUPONLESS_SAVINGS",
    // cross sell resposition
    MENU_ITEMS_ADDED_TO_CART: "MENU_ITEMS_ADDED_TO_CART",
    CART_CROSS_SELL_ITEMS_SUGGESTION: "CART_CROSS_SELL_ITEMS_SUGGESTION",
    // freebie widget
    SNACC_FREEBIE_WIDGET: "SNACC_FREEBIE_WIDGET",
    // Banner
    BANNER_WIDGET: "BANNER_WIDGET",
    // steal deal widget
    STEAL_DEAL_WIDGET: "STEAL_DEAL_WIDGET",
    // bill details section end
    BILL_DETAILS_SECTION_END: "BILL_DETAILS_SECTION_END",
};

export const VALID_BILL_ITEMS = [
    VALID_RENDERING_DETAILS_TYPE.BUTTON,
    VALID_RENDERING_DETAILS_TYPE.CARD_INFORMATION,
    VALID_RENDERING_DETAILS_TYPE.COUPON_BUTTON,
    VALID_RENDERING_DETAILS_TYPE.COUPON_REMOVE_BUTTON,
    VALID_RENDERING_DETAILS_TYPE.COUPONLESS_SAVINGS,
    VALID_RENDERING_DETAILS_TYPE.IM_COUPONLESS_SAVINGS,
    VALID_RENDERING_DETAILS_TYPE.DELIVERY_FEE_DISCOUNT,
    VALID_RENDERING_DETAILS_TYPE.DISPLAY,
    VALID_RENDERING_DETAILS_TYPE.FREE_TEXT_INPUT,
    VALID_RENDERING_DETAILS_TYPE.INFODISPLAY,
    VALID_RENDERING_DETAILS_TYPE.SEPARATOR,
    VALID_RENDERING_DETAILS_TYPE.TITLE,
    VALID_RENDERING_DETAILS_TYPE.TOOLTIPDISPLAY,
    VALID_RENDERING_DETAILS_TYPE.TRANSPARENT_SEPARATOR,
    VALID_RENDERING_DETAILS_TYPE.SUPER_V3_NUDGE,
    VALID_RENDERING_DETAILS_TYPE.SUPER_V3_BENEFITS,
    VALID_RENDERING_DETAILS_TYPE.DELIVERY_INSTRUCTIONS,
    VALID_RENDERING_DETAILS_TYPE.DELIVERY_SPEED,
    VALID_RENDERING_DETAILS_TYPE.SELF_DELIVERY_INSTRUCTIONS,
    VALID_RENDERING_DETAILS_TYPE.OFFER_BUNDLE_BENEFITS,
    VALID_RENDERING_DETAILS_TYPE.OFFER_BUNDLE_NUDGE,
    VALID_RENDERING_DETAILS_TYPE.CART_CBCC_NUDGE,
];

export const RENDERING_DETAILS_TYPES = {
    GRAND_TOTAL: "GRAND_TOTAL",
    COUPON_DISCOUNT: "COUPON_DISCOUNT",
    DELIVERY_CHARGES: "DELIVERY_CHARGES",
    EXCLUSIVE_OFFER_SWIGGY_ONE: "EXCLUSIVE_OFFER_SWIGGY_ONE",
    POSITIVE_DELIVERY_CHARGES_EXCLUSIVE_SWIGGY_ONE: "POSITIVE_DELIVERY_CHARGES_EXCLUSIVE_SWIGGY_ONE",
    EXCLUSIVE_OFFER_SWIGGY_ONE_LITE: "EXCLUSIVE_OFFER_SWIGGY_ONE_LITE",
    POSITIVE_DELIVERY_CHARGES_EXCLUSIVE_SWIGGY_ONE_LITE: "POSITIVE_DELIVERY_CHARGES_EXCLUSIVE_SWIGGY_ONE_LITE",
    ADD_DELIVERY_TIP: "ADD_DELIVERY_TIP",
    PRIORITY_DELIVERY_FEE: "PRIORITY_DELIVERY_FEE",
    NO_RUSH_DELIVERY_DISCOUNT: "NO_RUSH_DELIVERY_DISCOUNT",
    ITEM_TOTAL: "ITEM_TOTAL",
    POSITIVE_DELIVERY_CHARGES_EXCLUSIVE: "POSITIVE_DELIVERY_CHARGES_EXCLUSIVE",
    POSITIVE_DELIVERY_CHARGES_EXCLUSIVE_SWIGGY_BLACK: "POSITIVE_DELIVERY_CHARGES_EXCLUSIVE_SWIGGY_BLACK",
    FREE_99_STORE_DELIVERY_FEE: "FREE_99_STORE_DELIVERY_FEE",
    OFFER_BUNDLE_TOTAL: "OFFER_BUNDLE_TOTAL",
    BILL_HEADING: "BILL_HEADING",
    PLATFORM_FEE: "PLATFORM_FEE",
    PARTIAL_PLATFORM_FEE: "PARTIAL_PLATFORM_FEE",
    FREE_PLATFORM_FEE: "FREE_PLATFORM_FEE",
    POSITIVE_DELIVERY_CHARGES: "POSITIVE_DELIVERY_CHARGES",
    SUBSCRIPTION_TOTAL: "SUBSCRIPTION_TOTAL",
    SUBSCRIPTION_TOTAL_SWIGGY_ONE_LITE: "SUBSCRIPTION_TOTAL_SWIGGY_ONE_LITE",
    POCKET_HERO_CASHBACK: "POCKET_HERO_CASHBACK",
    TAXES_AND_CHARGES: "TAXES_AND_CHARGES",
    // gifting cart
    IM_COUPONLESS_SAVINGS: "IM_COUPONLESS_SAVINGS",
    // delivery details keys
    DELIVERY_CHARGES_SWIGGY_ONE: "DELIVERY_CHARGES_SWIGGY_ONE",
    FREE_DELIVERY_CHARGES_99_STORE: "FREE_DELIVERY_CHARGES_99_STORE",
    DELIVERY_CHARGES_SWIGGY_ONE_LITE: "DELIVERY_CHARGES_SWIGGY_ONE_LITE",
    DELIVERY_CHARGES_SWIGGY_ONE_BLACK: "DELIVERY_CHARGES_SWIGGY_ONE_BLACK",
    OFFER_CASH_REWARD: "OFFERCASHREWARD",
};

export enum BillDetailsTag {
    BLCK = "BLCK",
    ONE = "ONE",
    _99STORE = "99Store",
}

export const COUPON_SAVINGS_LINE_ITEMS = [
    VALID_RENDERING_DETAILS_TYPE.COUPON_BUTTON,
    VALID_RENDERING_DETAILS_TYPE.COUPON_REMOVE_BUTTON,
    VALID_RENDERING_DETAILS_TYPE.COUPONLESS_SAVINGS,
    VALID_RENDERING_DETAILS_TYPE.PAYMENT_COUPON_BUTTON,
    VALID_RENDERING_DETAILS_TYPE.PAYMENT_COUPON_REMOVE_BUTTON,
    VALID_RENDERING_DETAILS_TYPE.IM_COUPONLESS_SAVINGS,
];

export const SAVINGS_BENEFITS_LINE_ITEMS = [VALID_RENDERING_DETAILS_TYPE.SNACC_FREE_DEL_BENEFITS];

export const SUPER_SAVINGS_LINE_ITEMS = [
    VALID_RENDERING_DETAILS_TYPE.SUPER_V3_NUDGE,
    VALID_RENDERING_DETAILS_TYPE.SUPER_V3_BENEFITS,
];

export const DELIVERY_SECTION_ITEM_TYPES = [
    VALID_RENDERING_DETAILS_TYPE.CARD_INFORMATION,
    VALID_RENDERING_DETAILS_TYPE.DELIVERY_INSTRUCTIONS,
    VALID_RENDERING_DETAILS_TYPE.DELIVERY_SPEED,
    VALID_RENDERING_DETAILS_TYPE.SELF_DELIVERY_INSTRUCTIONS,
];

export const OTHER_CART_ITEM_TYPES = [
    VALID_RENDERING_DETAILS_TYPE.DELIVERY_FEE_DISCOUNT,
    VALID_RENDERING_DETAILS_TYPE.OFFER_BUNDLE_BENEFITS,
    VALID_RENDERING_DETAILS_TYPE.OFFER_BUNDLE_NUDGE,
    VALID_RENDERING_DETAILS_TYPE.CART_CBCC_NUDGE,
];

export const DELIVERY_FEE_AND_EXTRA_SAVINGS_LINE_ITEMS = [
    VALID_RENDERING_DETAILS_TYPE.DELIVERY_FEE_SAVINGS,
    VALID_RENDERING_DETAILS_TYPE.REWARD_OFFER_SAVINGS,
];

export const CART_WIDGET_TYPES = [
    VALID_RENDERING_DETAILS_TYPE.STEAL_DEAL_WIDGET,
    VALID_RENDERING_DETAILS_TYPE.SNACC_FREEBIE_WIDGET,
    VALID_RENDERING_DETAILS_TYPE.MENU_ITEMS_ADDED_TO_CART,
    VALID_RENDERING_DETAILS_TYPE.CART_CROSS_SELL_ITEMS_SUGGESTION,
];
export const SAVINGS_LINE_ITEM_BOTTOM_SHEET_TYPE = {
    FOOTER_COMMS: "footer-comms",
    TOOLTIP: "tooltip",
};
